if (!customElements.get('bundle-variant-picker')) {
    class BundleVariant extends HTMLElement {
        constructor() {
            super();
        }
        connectedCallback() {
            try {
                document.addEventListener('product:variant-change', (evt) =>{
                    if(!evt.detail.variant.available) {
                        let input = document.querySelector('bundle-variant-picker').querySelector('input[type="radio"]')
                        if(input) {
                            input.checked = true
                            input.dispatchEvent(new Event('change', {
                                bubbles: true
                            }));
                        }
                    }
                })
            } catch (error) {
                console.error('[BundleVariant] Initialization error:', error);
            }
        }
    }

    customElements.define('bundle-variant-picker', BundleVariant);
}